<template>
    <card class="simulation card-pricing bg-gradient-default border-0 text-center mb-2"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
        v-if="simulation">

        <simulation-info :registration="registration" :simulation="simulation"></simulation-info>

        <div class="display-3 text-white mb-3">
            <span class="text-muted d-inline">{{ registration.degree.name }} /</span>
            {{ simulation.name }}
        </div>

        <div v-if="session">
            <div class="row" v-if="session.learner1 && session.learner2">
                <div class="col-sm-4 text-center pb-2">
                    <div v-if="!canAccessLearnersFiles">
                        <span class="avatar rounded-circle">
                            <img alt="Image placeholder" :src="session.learner1.avatar">
                        </span>
                    </div>
                    <div v-else>
                        <a href="#" @click.prevent="editLearner(session.learner1)" class="avatar rounded-circle">
                            <img alt="Image placeholder" :src="session.learner1.avatar">
                        </a>
                    </div>
                    <div>
                        <h4 class="text-white mb-0" v-if="!canAccessLearnersFiles">
                            {{ session.learner1.name }}
                        </h4>
                        <h4 class="text-white mb-0" v-else>
                            <a href="#" @click.prevent="editLearner(session.learner1)">
                                {{ session.learner1.name }}
                            </a>
                        </h4>
                        <small class="text-muted position">
                            {{ registration.degree.simulation_role_1_name[registration.degree.lang] }}
                            <span v-if="registration.degree.simulation_role_2">
                                / {{ registration.degree.simulation_role_2_name[registration.degree.lang] }}
                            </span>
                        </small>
                    </div>
                </div>
                <div class="col-sm-4 text-center pb-2">
                    <div v-if="!canAccessLearnersFiles">
                        <span class="avatar rounded-circle">
                            <img alt="Image placeholder" :src="session.instructor.avatar">
                        </span>
                    </div>
                    <div v-else>
                        <a href="#" @click.prevent="editSession()" class="avatar rounded-circle">
                            <img alt="Image placeholder" :src="session.instructor.avatar">
                        </a>
                    </div>
                    <div>
                        <h4 class="text-white mb-0" v-if="!canAccessLearnersFiles">
                            {{session.instructor.name}}
                        </h4>
                        <h4 class="text-white mb-0" v-else>
                            <a href="#" @click.prevent="editSession()">
                                {{session.instructor.name}}
                            </a>
                        </h4>
                        <small class="text-muted">
                            {{ $t('common.instructor') }}
                        </small>
                    </div>
                </div>
                <div class="col-sm-4 text-center pb-2">
                    <div v-if="!canAccessLearnersFiles">
                        <span class="avatar rounded-circle">
                            <img alt="Image placeholder" :src="session.learner2.avatar">
                        </span>
                    </div>
                    <div v-else>
                        <a href="#" @click.prevent="editLearner(session.learner2)" class="avatar rounded-circle">
                            <img alt="Image placeholder" :src="session.learner2.avatar">
                        </a>
                    </div>
                    <div>
                        <h4 class="text-white mb-0" v-if="!canAccessLearnersFiles">
                            {{session.learner2.name}}
                        </h4>
                        <h4 class="text-white mb-0" v-else>
                            <a href="#" @click.prevent="editLearner(session.learner2)">
                                {{session.learner2.name}}
                            </a>
                        </h4>
                        <small class="text-muted position">
                            <span v-if="registration.degree.simulation_role_2">
                                {{ registration.degree.simulation_role_2_name[registration.degree.lang] }} /
                            </span>
                            {{ registration.degree.simulation_role_1_name[registration.degree.lang] }}
                        </small>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="row">
                    <div class="col-sm-6 text-center pb-2">
                        <div v-if="!canAccessLearnersFiles">
                            <span class="avatar rounded-circle">
                                <img alt="Image placeholder" :src="learner.avatar">
                            </span>
                        </div>
                        <div v-else>
                            <a href="#" @click.prevent="editLearner(learner)" class="avatar rounded-circle">
                                <img alt="Image placeholder" :src="learner.avatar">
                            </a>
                        </div>
                        <div>
                            <h4 class="text-white mb-0" v-if="!canAccessLearnersFiles">
                                {{learner.name}}
                            </h4>
                            <h4 class="text-white mb-0" v-else>
                                <a href="#" @click.prevent="editLearner(learner)">
                                    {{learner.name}}
                                </a>
                            </h4>
                            <div class="mb-2">
                                <small class="text-muted position">
                                    {{ position1 }}
                                    <span v-if="position2">
                                        / {{ position2 }}
                                    </span>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 text-center pb-2">
                        <div v-if="!canAccessLearnersFiles">
                            <span class="avatar rounded-circle">
                                <img alt="Image placeholder" :src="session.instructor.avatar">
                            </span>
                        </div>
                        <div v-else>
                            <a href="#" @click.prevent="editSession()" class="avatar rounded-circle">
                                <img alt="Image placeholder" :src="session.instructor.avatar">
                            </a>
                        </div>
                        <div>
                            <h4 class="text-white mb-0" v-if="!canAccessLearnersFiles">
                                {{ session.instructor.name }}
                            </h4>
                            <h4 class="text-white mb-0" v-else>
                                <a href="#" @click.prevent="editSession()">
                                    {{ session.instructor.name }}
                                </a>
                            </h4>
                            <small class="text-muted">
                                {{ $t('common.instructor') }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-2 mt-3"
                v-if="!session.started_at && $permissions.hasRight('dashboard.learners.write')">

                <base-button type="secondary" @click="switchPositions"
                    v-if="registration.degree.simulation_role_2"
                >
                    <i class="fas fa-sync-alt mr-1"></i> {{ $t('sessions.switch-positions') }}
                </base-button>
                
                <base-button type="secondary" @click="startSimulation">
                    <i class="fas fa-play mr-1"></i> {{ $t('common.start') }}
                </base-button>

            </div>
            <div class="mb-2 mt-3" v-else-if="$permissions.hasRight('dashboard.pilot-log.access')">

                <base-button type="secondary" @click="editSimulation">
                    <i class="fas fa-pencil-alt mr-1"></i> {{ $t('common.issues') }}
                </base-button>
                
            </div>
        </div>

        <div class="mb-2 mt-3"
            v-else-if="$permissions.hasRight('dashboard.pilot-log.access')"
        >
            <base-button type="secondary" v-if="!inLog" @click="openPilotLog">
                <i class="fas fa-play mr-1"></i> {{ $t('common.log') }}
            </base-button>

            <base-button type="secondary" v-if="canAccessIssues" @click="openPilotSummary">
                <i class="fas fa-pencil-alt mr-1"></i> {{ $t('common.issues') }}
            </base-button>
        </div>

        <div class="mt-4 mb-2" v-if="session && session.sync">
            <span :class="'sync-notice bg-' + session.sync.color">
                <strong>{{ $t('pwa.offline-mode') }}:</strong> {{ $t('pwa.local-notice-' + session.sync.color) }}
            </span>
        </div>
        <div class="mt-4 mb-2" v-else-if="sync">
            <span :class="'sync-notice bg-' + sync.color">
                <strong>{{ $t('pwa.offline-mode') }}:</strong> {{ $t('pwa.local-notice-' + sync.color) }}
            </span>
        </div>

        <portal to="modals">

            <confirm-modal v-model="modals.confirmStart">
                <p>{{ $t('sessions.start-confirm') }}</p>
            </confirm-modal>

        </portal>
    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import SimulationInfo from '../../dashboard/common/SimulationInfo'

    export default {

        components: {
            SimulationInfo
        },

        model: {
            prop: 'session',
            event: 'change'
        },

        props: {

            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                default: null
            },

            sync: {
                type: Object,
                default: null
            },

            inLog: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                modals: new ModalsController(['confirmStart']),
            }
        },

        created() {
            this.modals.init(this, 'modals')
        },

        computed: {

            learner() {
                // Return the learner for single learner sessions.
                return this.session.learner1 ? this.session.learner1 : this.session.learner2
            },

            position1() {
                // Return the position 1 for single learner sessions.
                if (this.session.learner1) {
                    return this.registration.degree.simulation_role_1_name[this.registration.degree.lang]
                } else {
                    return this.registration.degree.simulation_role_2_name[this.registration.degree.lang]
                }
            },

            position2() {
                // Return the position 2 for single learner sessions.
                if (this.session.learner1) {
                    if (!this.registration.degree.simulation_role_2) {
                        return null
                    }
                    return this.registration.degree.simulation_role_2_name[this.registration.degree.lang]
                } else {
                    return this.registration.degree.simulation_role_1_name[this.registration.degree.lang]
                }
            },

            canAccessLearnersFiles() {
                return this.$permissions.hasRight('dashboard.learners.read') && !this.isUserOffline
            },

            canAccessIssues() {
                return this.inLog && !this.isUserOffline
            },

            isUserOffline() {
                return this.$auth.offline
            },

            /*
            isSessionOffline() {
                return this.sync || (this.session && this.session.sync)
            }
            */
        },

        methods: {

            switchPositions() {
                axios.post('/astral/api/front/dashboard/sessions/'+this.session.id+'/switch')
                .then(resp => {
                    this.$emit('change', resp.data.data)
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },

            startSimulation() {
                this.modals.open('confirmStart').then(confirmResponse => {
                    if (confirmResponse.confirmed) {
                        this.$loader.show()
                        axios.post('/astral/api/front/dashboard/sessions/'+this.session.id+'/start')
                        .then(resp => {
                            this.$loader.hide()
                            this.$emit('change', resp.data.data)
                        })
                        .catch(err => {
                            this.$auth.handleErrorVm(err, this)
                        })        
                    }
                })
            },

            editLearner(learner) {
                this.$router.push({ name: 'dashboard-learner-simulation-edit',
                    params: { 
                        learnerId: learner.id,
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                    }
                })
            },

            editSession() {
                this.$router.push({ name: 'log-session-summary',
                    params: { 
                        sessionId: this.session.id,
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                        groupId: this.$route.params.groupId ? this.$route.params.groupId : 0,
                    }
                })
            },

            editSimulation() {
                this.$router.push({ name: 'log-simulation-summary',
                    params: { 
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                        groupId: this.$route.params.groupId ? this.$route.params.groupId : 0,
                    }
                })
            },

            openPilotLog() {
                this.$router.push({
                    name: 'log-simulation-log',
                    params: {
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                        groupId: this.$route.params.groupId ? this.$route.params.groupId : 0,
                    }
                });
            },

            openPilotSummary() {
                this.$router.push({
                    name: 'log-simulation-summary',
                    params: {
                        registrationId: this.registration.id,
                        simulationId: this.simulation.id,
                        groupId: this.$route.params.groupId ? this.$route.params.groupId : 0,
                    }
                });
            },
        }
    }
</script>

<style scoped>

    a:hover {
        color: #ffffff;
    }
    .sync-notice {
        color: #ffffff;
        padding: .2rem .6rem;
        border-radius: .375rem;
        font-size: 0.8rem;
    }
    .bg-success {
        background-color: #22a069 !important;
    }
    .position {
        font-size: 120%;
    }

</style>
